import { POSLeaderboardApiRepository } from "@/app/infrastructures/repositories/api/POSLeaderboardApiRepository";
import { SummaryApiRequest } from "@/data/payload/api/PosLeaderboard";
import { PosLeaderboard } from "@/domain/entities/PosLeaderboard";
import { POSLeaderboardListRequest } from "@/data/payload/api/POSLeaderboardApiRequest";
import { injectable } from "tsyringe";

@injectable()
export class POSLeaderboardPresenter {
  private repository: POSLeaderboardApiRepository;

  constructor(repository: POSLeaderboardApiRepository) {
    this.repository = repository;
  }

  public getSummary(params: SummaryApiRequest): Promise<PosLeaderboard> {
    return this.repository.getSummary(params);
  }

  getLeaderboardList(params: POSLeaderboardListRequest) {
    return this.repository.getLeaderboardList(params);
  }

  getConfig(params: SummaryApiRequest) {
    return this.repository.getConfig(params);
  }
}

